import { useTranslation } from 'react-i18next';
import { useLang } from '@/hooks/useLang';

export default function Footer() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href={`/${lang}/`} className="flex items-center gap-2 mb-4">
              <span className="font-heading text-lg font-semibold text-foreground-950">AllChinaBuy</span>
              <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">Spreadsheet</span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t('footer.tagline')}</p>
            <div className="flex gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 transition-colors">
                <i className="ri-global-line" />
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">{t('footer.resources')}</h3>
            <ul className="space-y-2.5">
              <li><a href={`/${lang}/allchinabuy-spreadsheet/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.spreadsheet')}</a></li>
              <li><a href={`/${lang}/products/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.categories')}</a></li>
              <li><a href={`/${lang}/allchinabuy-review/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.review')}</a></li>
              <li><a href={`/${lang}/allchinabuy-shipping/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.shipping')}</a></li>
              <li><a href={`/${lang}/allchinabuy-coupon/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.coupon')}</a></li>
              <li><a href={`/${lang}/allchinabuy-warehouse/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.warehouse')}</a></li>
              <li><a href={`/${lang}/allchinabuy-legit/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.legit')}</a></li>
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">{t('footer.guides')}</h3>
            <ul className="space-y-2.5">
              <li><a href={`/${lang}/allchinabuy-spreadsheet/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">AllChinaBuy Spreadsheet Guide</a></li>
              <li><a href={`/${lang}/allchinabuy-shipping/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Shipping Guide</a></li>
              <li><a href={`/${lang}/allchinabuy-warehouse/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Warehouse Guide</a></li>
              <li><a href={`/${lang}/allchinabuy-legit/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Safety Guide</a></li>
              <li><a href={`/${lang}/allchinabuy-coupon/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Coupon Guide</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2.5">
              <li><a href={`/${lang}/about/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.about')}</a></li>
              <li><a href={`/${lang}/contact/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.contact')}</a></li>
              <li><a href={`/${lang}/privacy-policy/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.privacy')}</a></li>
              <li><a href={`/${lang}/terms/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.terms')}</a></li>
              <li><a href={`/${lang}/disclaimer/`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('footer.disclaimer')}</a></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-6 border-t border-background-200/70">
          <p className="text-xs text-foreground-500 leading-relaxed">{t('footer.disclaimerText')}</p>
        </div>

        {/* Copyright */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} allchinabuyspread.asia. {t('footer.rights')}</p>
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-primary-600 hover:text-primary-700 font-medium">
            Visit Main Website →
          </a>
        </div>
      </div>
    </footer>
  );
}